import { urlBase, urlAuth } from './urls';
import { authHeader } from './../helpers/authHeader';

export const userService = {
    login,
    logout,
    register,
    getAll,
    getById,
    update,
    delete: _delete
};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`${urlAuth}`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${urlBase}users`, requestOptions).then(handleResponse);
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${urlBase}users/${id}`, requestOptions).then(handleResponse);
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${urlBase}users/register`, requestOptions).then(handleResponse);
}


function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${urlBase}users/${user.id}`, requestOptions).then(handleResponse);;
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${urlBase}users/${id}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                // location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}

export const serverCreateUser= (url, data) => () => {
    let token = localStorage["auth"]
    let urlSend = `${url}`
    // console.log('serverCreateUser ', urlSend)
    return fetch(urlSend, {
      method: 'POST',
      headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token}),
      body: JSON.stringify(data),
    }).then(v => v.json())
    .then(r => {
        // console.log('se obtiene ', r)
        if (r.message) {
          return Promise.reject(r.validation);
        }
        return r
    });
}

export const serverUpdateUser= (url, id, data) => () => {
    let token = localStorage["auth"]
    let urlSend = `${url}/${id}`
    // console.log('serverUpdateUser ', urlSend)
    return fetch(urlSend, {
      method: 'PATCH',
      headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token}),
      body: JSON.stringify(data),
    }).then(v => v.json())
    .then(r => {
        // console.log('se obtiene ', r)
        if (r.message) {
          return Promise.reject(r.validation);
        }
        return r
    });
}